import { useQuery } from '@tanstack/react-query'
import { api } from './client'
import type { Currency } from './types'

export function useCurrencies() {
  return useQuery({
    queryKey: ['currencies'],
    queryFn: async () => {
      const { data, error } = await api.GET('/currencies')
      if (error) throw error
      return data as Currency[]
    },
  })
}

export function useExponentByCode(): Record<string, number> {
  const { data } = useCurrencies()
  const map: Record<string, number> = {}
  for (const currency of data ?? []) map[currency.code] = currency.exponent
  return map
}

export function useChildren() {
  return useQuery({
    queryKey: ['children'],
    queryFn: async () => {
      const { data, error } = await api.GET('/children')
      if (error) throw error
      return data
    },
  })
}

export function useSummary() {
  return useQuery({
    queryKey: ['summary'],
    queryFn: async () => {
      const { data, error } = await api.GET('/summary')
      if (error) throw error
      return data
    },
  })
}
